// extracted by mini-css-extract-plugin
export var columnLayout = "columnLayout-module--column-layout--HqCJp";